// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Io3lq","content":"Consent_content__2PBc1","footer":"Consent_footer__1MDLv"};